// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-167612fa] {\n  font-size: 12px;\n  line-height: 16px;\n  color: #465366;\n}\ntable[data-v-167612fa] {\n  width: 100%;\n}\ntd[data-v-167612fa] {\n  padding: 17px;\n}\ntbody tr[data-v-167612fa]:nth-child(odd) {\n  background: #f1f3f6;\n}\n.handle[data-v-167612fa] {\n  cursor: move;\n  cursor: -webkit-grab;\n  cursor: grab;\n  margin-right: 19px;\n}\n.handle[data-v-167612fa]:active {\n  cursor: -webkit-grabbing;\n  cursor: grabbing;\n}\n", ""]);
// Exports
module.exports = exports;
